"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function set(obj, path, value) {
    var pathArray = path === null || path === void 0 ? void 0 : path.split(".");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pathArray === null || pathArray === void 0 ? void 0 : pathArray.reduce(function (acc, key, i) {
        // Initialize property if it is not yet created
        if (acc[key] === undefined)
            acc[key] = {};
        // If current key is the last field, set the value
        if (i === pathArray.length - 1)
            acc[key] = value;
        return acc[key];
    }, obj);
}
exports.default = set;
